import clsx from "clsx";
import type { FunctionComponent } from "react";

interface TopHeadProps {
  children: React.ReactNode;
  type?: "text" | "sp-line";
}

const TopHead: FunctionComponent<TopHeadProps> = ({
  children,
  type = "sp-line",
}) => {
  return (
    <h2
      className={clsx(
        "text-center",
        "text-40",
        "font-bold",
        "font-en",
        "tracking-[1px]",
        "max-md:text-20",
        type === "sp-line" && "max-md:grid",
        type === "sp-line" && "max-md:gap-10",
        type === "sp-line" && "max-md:pl-15",
        type === "sp-line" && "max-md:grid-cols-[auto_3fr_1fr]",
        "items-center",
      )}
    >
      {children}
      {type === "sp-line" && (
        <div className={clsx("h-1", "bg-black", "sp_only")}></div>
      )}
      <div className={clsx()}></div>
    </h2>
  );
};

export default TopHead;
